import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';
import { stepsData } from '../lib/data';
import styles from './Steps.module.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { Button } from '../../../shared/ui/Button/Button';
import { Link } from 'react-router-dom';



gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Steps = () => {
    useGSAP(() => {
        gsap.to(".title__steps", { "--opacity": 1, "--x": "0px",
                                    y:-10,  
                                    duration: 1, 
                                    scrollTrigger: {
                                        trigger: ".title__steps"
        }});
        gsap.fromTo(".step__id", {"--opacity": 0, y:-10,}, 
                                {"--opacity": 1,
                                    y:0,  
                                    duration: 3, 
                                    delay: 1, 
                                    scrollTrigger: {
                                        trigger: ".step__id"
        }})
    }, [])
    return ( 
        <section className={styles.container}>
            <Stack  className={styles.title__content}>
                <Text type="h2" size='xl' className={`title__steps ${styles.title}`}>
                    ВАШ ПУТЬ К ЗДОРОВОЙ И КРАСИВОЙ УЛЫБКЕ
                </Text>    
            </Stack>
            <Stack
                direction='column'
                alignItems='alignStart'
                className={styles.step__container}
                gap= '16'
            >
            {stepsData.map(element => 
                <Stack
                    gap='32'    
                    alignItems='alignCenter'                       
                    className={styles.step__content}
                    key={element.id}>
                    <Stack>
                        <Text type = 'h4' size='xxl' className= {`step__id ${styles.step__id}`}>
                            {element.id}
                        </Text>
                    </Stack>
                    <Stack 
                        direction='column'
                        alignItems='alignStart'
                        className={styles.text}
                        gap='8'
                    >
                        <Text  type = 'h4' size='l' className={styles.step__title}>
                            {element.title}
                        </Text>
                        <Text className={styles.description}>
                            {element.description}
                        </Text>
                    </Stack>
                </Stack>
            )}
            </Stack>

            <Button variant = 'secondary' className={styles.btn}>
                        <Link to= "/plan" className={styles.link}>
                               индивидуальный план лечения
                        </Link>
            </Button>
        </section>
     );
}
 
export default Steps;